// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Word_bold__1svy_ {\n  font-weight: bold;\n}\n.Word_color__3L6P0 {\n  font-weight: 600;\n  color: var(--background-creneau-normal);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Misc/Word.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,uCAAuC;AACzC","sourcesContent":[".bold {\n  font-weight: bold;\n}\n.color {\n  font-weight: 600;\n  color: var(--background-creneau-normal);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bold": "Word_bold__1svy_",
	"color": "Word_color__3L6P0"
};
export default ___CSS_LOADER_EXPORT___;
